module.exports = __webpack_public_path__ + "img/-1440x900 (1).9bf19642.jpg";